import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom'

import Logo from './pages/logo'
import Frame from './pages/frame'


class App extends Component {
  constructor() {
    super();
    this.state = {
      grid: 1
    }
  }
 
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={Logo} />
          <Route path="/" render={() => <Frame grid={this.state.grid} />} />
        </Switch>
      </Router>
    );
  }
}

export default App;
